import { createStorefrontApiClient } from "@shopify/storefront-api-client"

const client = createStorefrontApiClient({
  storeDomain: process.env.GATSBY_MYSHOPIFY_URL || "orchard-pig.myshopify.com",
  apiVersion: process.env.GATSBY_SHOPIFY_API_VERSION || "2024-04",
  publicAccessToken: process.env.GATSBY_SHOPIFY_API_TOKEN,
})

export default client
